import { render, staticRenderFns } from "./HotelTab.vue?vue&type=template&id=b20c454a&scoped=true&"
import script from "./HotelTab.vue?vue&type=script&lang=js&"
export * from "./HotelTab.vue?vue&type=script&lang=js&"
import style0 from "./HotelTab.vue?vue&type=style&index=0&id=b20c454a&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b20c454a",
  null
  
)

export default component.exports